import { Typography } from '@material-ui/core'
import PublicWrapper from '../public-wrapper-v2/public-wrapper'
import useThankYouStyles from './thank-you.styles'
import STATIC_TEXT from '../../content/common.json'
import completeIcon from '../../assets/icon-status-complete.svg'
import inProgressIcon from '../../assets/icon-status-in-progress.svg'
import incomplete from '../../assets/icon-status-incomplete.svg'
import ArrowForward from '@mui/icons-material/ArrowForward'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { logout } from '../../stores/async/identity-async-actions'

export const ThankYou = () => {
    const classes = useThankYouStyles()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(logout())
    }, [])

    return (
        <div className={classes.trapezoidBg}>
            <PublicWrapper data-testid="publicWrapper" displayPrivacyPolicyFooter={true} contentWrapperClass={classes.thankYouWrapper}>
                <div className={classes.thankYouBox}>
                    <Typography variant="h2" className={classes.bannerTitle}>
                        {STATIC_TEXT.loanStatus.title}
                    </Typography>
                    <Typography variant="h2" className={classes.heading}>
                        {STATIC_TEXT.loanStatus.heading}
                    </Typography>
                    <Typography variant="body2" className={classes.additionalContent}>
                        {STATIC_TEXT.loanStatus.additionalContentNew}
                    </Typography>
                    <Typography component="div" variant="body2" className={classes.learnMoreRow}>
                        <a
                            href="https://www.svb.com/startup-insights/venture-debt"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.learnMoreLink}
                        >
                            {STATIC_TEXT.loanStatus.content4}
                        </a>
                        <ArrowForward className={classes.arrowIcon} />
                    </Typography>
                </div>

                <div className={classes.applicationBox}>
                    <div className={classes.applicationContent}>
                        <Typography variant="h2" className={classes.applicationStatusTitle}>
                            {STATIC_TEXT.loanStatus.heading5}
                        </Typography>
                        <div className={classes.statusBullets}>
                            <div className={classes.statusRow}>
                                <img src={completeIcon} className={classes.statusIcon} alt="" />
                                <Typography variant="h2" className={classes.statusText}>
                                    {STATIC_TEXT.loanStatus.heading1}
                                </Typography>
                            </div>
                            <div className={classes.dottedLine} />
                            <div className={classes.statusRow}>
                                <img src={inProgressIcon} className={classes.statusIcon} alt="" />
                                <Typography variant="h2" className={classes.statusText}>
                                    {STATIC_TEXT.loanStatus.heading2}
                                </Typography>
                            </div>
                            <div className={classes.dottedLine} />
                            <div className={classes.statusRow}>
                                <img src={incomplete} className={classes.statusIcon} alt="" />
                                <Typography variant="h2" className={classes.statusText}>
                                    {STATIC_TEXT.loanStatus.heading3}
                                </Typography>
                            </div>
                            <div className={classes.dottedLine} />
                            <div className={classes.statusRow}>
                                <img src={incomplete} className={classes.statusIcon} alt="" />
                                <Typography variant="h2" className={classes.statusText}>
                                    {STATIC_TEXT.loanStatus.heading4}
                                </Typography>
                            </div>
                        </div>
                    </div>
                </div>
            </PublicWrapper>
        </div>
    )
}
